import React from 'react'
import { Link } from 'react-router-dom'
import { Screen } from '../../components/lease/Screen'
import { BrandHeading } from '../../components/lease/BrandHeading'

// Ported from the LeaseWise-Frontend mockup "5c Disclaimer.png".
// PENDING TEZ LEGAL REVIEW — tracked in active-tasks.
const SECTIONS = [
  ['No Legal Advice', 'The information provided by Lease Check ("we," "us," or "our") is for general informational purposes only and does not constitute legal advice. While we strive to ensure that the content is accurate and up-to-date, laws and regulations change regularly, and interpretations can vary. Users should consult with a qualified attorney for legal advice specific to their situation.'],
  ['No Attorney-Client Relationship', 'Your use of Lease Check does not create an attorney-client relationship between you and Lease Check or any of its representatives. Communications through the app are not privileged or confidential.'],
  ['Use at Your Own Risk', 'You acknowledge that any reliance on the information provided by Lease Check is at your own risk. We make no warranties or representations about the accuracy or completeness of the content. We are not responsible for any errors or omissions or for any results obtained from the use of this information.'],
  ['Jurisdictional Limitations', 'Legal requirements and regulations vary by state and locality. Lease Check may not cover all jurisdictions or reflect the most current legal developments. It is your responsibility to ensure compliance with all applicable laws and regulations in your area.'],
  ['Limitation of Liability', 'In no event shall Lease Check, nor its directors, employees, agents, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the app.'],
  ['Third-Party Links and Resources', 'Our app may contain links to third-party websites or resources for your convenience. We do not endorse any third-party content and are not responsible for their accuracy or reliability.'],
  ['No Guarantee', 'We do not guarantee that Lease Check will be free from errors, omissions, or inaccuracies. The app is provided on an "as-is" basis without any warranties of any kind, either express or implied.'],
  ['Changes to This Disclaimer', 'We reserve the right to modify this disclaimer at any time. Changes will be effective immediately upon posting. Your continued use of Lease Check signifies your acceptance of the updated terms.'],
]

function Disclaimer() {
  return (
    <Screen className="max-w-2xl">
      <header className="animate-fade-in text-center">
        <BrandHeading className="text-4xl">Legal Disclaimer</BrandHeading>
      </header>
      <div className="mt-5 animate-slide-in space-y-3 text-center text-sm text-slate-600 dark:text-slate-300">
        <p>Lease Check is here to help you better understand your lease agreement by providing general information and insights.</p>
        <p>Please note that the content provided is for informational purposes only and does not constitute legal advice.</p>
        <p>We strongly recommend consulting a qualified attorney for advice tailored to your specific situation.</p>
      </div>
      <div className="mt-6 animate-slide-in space-y-4">
        {SECTIONS.map(([title, body]) => (
          <section
            key={title}
            className="rounded-2xl bg-white/70 p-4 shadow-sm ring-1 ring-emerald-100 backdrop-blur dark:bg-slate-800/60 dark:ring-slate-700"
          >
            <h2 className="text-center font-semibold text-emerald-700 dark:text-emerald-400">{title}</h2>
            <p className="mt-1 text-sm leading-relaxed text-slate-700 dark:text-slate-200">{body}</p>
          </section>
        ))}
      </div>
      <div className="mt-8 animate-slide-in text-center">
        <Link
          to="/legal"
          className="inline-block w-full transform rounded-xl bg-gradient-to-r from-emerald-600 to-teal-600 py-4 text-lg font-bold text-white shadow-lg transition hover:-translate-y-0.5 hover:from-emerald-700 hover:to-teal-700 hover:shadow-xl"
        >
          Return to Legal Stuff
        </Link>
      </div>
    </Screen>
  )
}

export default Disclaimer
